<template>
  <div class="md-layout dash-layout">
    <h2>ProVPN Servers Map</h2>

    <md-progress-bar
      md-mode="query"
      :class="`${ processingMarkers ? 'visible-loader' : 'hidden-loader'}`"
    />

    <GmapMap
      v-if="!processingMarkers"
      :center="{lat: 50, lng: 30}"
      :zoom="2"
      map-type-id="terrain"
      class="dashboard-map"
    >
      <GmapMarker
        v-for="m in greenMarkers"
        :key="m.id"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        :icon="greenMarkerImage"
        @click="toggleInfoWindow(m)"
      />

      <GmapMarker
        v-for="m in redMarkers"
        :key="m.id"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        :icon="redMarkerImage"
        @click="toggleInfoWindow(m)"
      />

      <GmapInfoWindow
        :options="infoOptions"
        :position="infoWindowPosition"
        :opened="infoWindowOpen"
        @closeclick="infoWindowOpen=false"
      >
        <MapInfo :marker="infoWindowContent" />
      </GmapInfoWindow>
    </GmapMap>
    <span v-if="!isAllowedToSeeNodes">It's just a map, nothing to see here</span>
  </div>
</template>
<script>
    import redMarkerImage from "@/assets/img/map/red-marker.png";
    import greenMarkerImage from "@/assets/img/map/green-marker.png";
    import MapInfo from "@/components/Tables/MapInfo";

    import {SALES_ROLE, SUPPORT_ROLE, getUserRole} from "../assets/adminRoles";

    export default {
        components: {MapInfo},
        data() {
            const role = getUserRole();

            return {
                greenMarkers: [],
                redMarkers: [],
                infoWindows: [],
                processingMarkers: false,

                infoOptions: {
                    pixelOffset: {
                        width: 0,
                        height: -35
                    }
                },
                infoWindowContent: {},
                infoWindowPosition: undefined,
                infoWindowOpen: false,
                infoMarkerId: undefined,

                isAllowedToSeeNodes: role !== SALES_ROLE && role !== SUPPORT_ROLE,

                redMarkerImage,
                greenMarkerImage
            };
        },
        mounted() {
            this.fetchNodes();
        },
        methods: {
            fetchNodes() {
                if (!this.isAllowedToSeeNodes) {
                  return;
                }

                this.processingMarkers = true;
                this.$http.get("/v1/admin/nodes?filters.provider=ProVPN").then(result => {
                    const nodes = result.data.nodes;

                    const markers = nodes.map(n => ({
                        id: n.id,
                        position: {
                            lat: n.location.latitude,
                            lng: n.location.longitude
                        },
                        info: {
                            protocol: n.protocol,
                            ip: n.ip,
                            port: n.port,
                            is_enabled: n.is_enabled,
                            server_address: n.server_address
                        }
                    }));

                    this.greenMarkers = markers.filter(m => m.info.is_enabled);
                    this.redMarkers = markers.filter(m => !m.info.is_enabled);

                    this.processingMarkers = false;
                }, err => {
                    console.error(err);
                });
            },
            toggleInfoWindow(marker) {
                this.infoWindowPosition = marker.position;
                this.infoWindowContent = marker.info;
                this.infoWindowContent.id = marker.id;


                if (this.infoMarkerId === marker.id) {
                    this.infoWindowOpen = !this.infoWindowOpen;
                }
                else {
                    this.infoWindowOpen = true;
                    this.infoMarkerId = marker.id;
                }
            }
        }
    };
</script>
<style scoped>
    .dash-layout {
        display: flex;
        flex-direction: column;
    }
    .dashboard-map {
        width: 100%;
        height: 700px;
        min-height: 60%;
    }

    .visible-loader {
        opacity: 1;
    }
    .hidden-loader {
        opacity: 0;
    }
</style>
